import { Injectable, NgZone, ViewChild } from '@angular/core';
import { User } from '../service/user';
import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import 'firebase/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userData: any; // Save logged in user data
  img = document.getElementById('img');
  file = {};
  adminCode: any;
  isSuperAdmin : boolean;
  visible : boolean;

  constructor(
    public afs: AngularFirestore, // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    private db: AngularFireDatabase,
    private _snackBar: MatSnackBar,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe((user: firebase.User) => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
        this.afs
          .collection('users')
          .doc(user?.uid)
          .get()
          .toPromise()
          .then((payload: any) => {
            this.adminCode = payload?.data()?.adminCode;
          });
      } else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    });
    this.visible = true; //hide navigation
  }

  get isAdmin(): boolean {
    return (
      this.userData?.typeOfUser?.trim()?.toLowerCase() === 'admin' ||
      this.userData?.displayName?.trim()?.toLowerCase()?.includes('admin')
    );
  }

   /*get isSuperAdmin(): boolean {
     return (
       this.userData?.typeOfUser?.trim()?.toLowerCase() === 'super-admin' ||
       this.userData?.displayName?.trim()?.toLowerCase()?.includes('super-admin')
     );
   }*/

  get name(): string {
    return this.userData?.displayName;
  }

  anonymousSignIn() {
    firebase
      .auth()
      .signInAnonymously()
      .then(() => {
        this.router.navigate(['assessment']);
        console.log('clicking');
      })
      .catch((error) => {
        var errorCode = error.code;

        var errorMessage = error.message;
        console.log('error here');
      });
  }

  chooseFile(event) {
    this.file = event.target.files[0];
  }

  goToPayment() {
    return this.router.navigate(['payment-example']);
  }

  goToSignIn() {
    return this.router.navigate(['sign-in']);
  }

  goToAccount() {
    //return this.router.navigate(['account']);
    return (location.href = '/account');
  }

  // Sign in with email/password
  SignIn(email, password) {
    return this.afAuth
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.ngZone.run(() => {
          this.router.navigate(['account']);
        });
        this.SetUserData(result.user);
      })
      .catch((error) => {
        this._snackBar.open(error.message, '', {
          duration: 3000,
        });
        console.error(error.message);
      });
  }

  // Sign up with email/password
  SignUp(email, password) {
    return this.afAuth
      .createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        this.SendVerificationMail();
        this.SetUserData(result.user);
      })
      .catch((error) => {
        this._snackBar.open(error, '', {
          duration: 3000,
        });
        console.error(error.message);
      });
  }

  async onboardUpdate(
    displayName: string,
    typeOfUser: string,
    firstName: string,
    lastName: string,
    companyName: string,
    refferedBy: string,
    agreeToTerms:string
 
  ) {
    this.afAuth.authState.toPromise().then((payload) => payload.reload());
    const currentUser = await this.afAuth.currentUser;
    const profile = {
      displayName: displayName + ' ' + '|' + ' ' + typeOfUser,
      typeOfUser,
      emailVerified: currentUser.emailVerified,
      firstName,
      lastName,
      companyName,
      refferedBy,
      agreeToTerms
 
    };
    currentUser.updateProfile(profile);
    this.afs
      .collection('users')
      .doc(currentUser?.uid)
      .collection('actionItems')
      .doc('getStarted')
      .set({
        //gives users an action item collection
        actionItemName: 'Get Started',
        actionItemResourceName:
          'Take an assessment, then delete this action item!',
      });
    this.afs.collection('user-bPlan').doc(currentUser?.uid).set({
      //gives users a business plan doc
      userID: currentUser?.uid,
    });
    this.userData = { ...this.userData, ...profile };
    return this.afs
      .collection('users')
      .doc(currentUser?.uid)
      .set(profile, { merge: true })
      .then(() => this.goToAccount());
  }

  // Send email verfificaiton when new user sign up
  async SendVerificationMail() {
    return (await this.afAuth.currentUser).sendEmailVerification().then(() => {
      this.router.navigate(['verify-email-address']);
    });
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth
      .sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        this._snackBar.open(
          'Password reset email sent, check your inbox.',
          '',
          {
            duration: 3000,
          }
        );
        this.router.navigate(['sign-in']);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null && user.emailVerified !== false ? true : false;
  }

  // Sign in with Google
  SignUpGoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider()).then(() => {
      this.router.navigate(['onboard']);
    });
  }

  SignInGoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider()).then(() => {
      this.router.navigate(['account']);
    });
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return this.afAuth
      .signInWithPopup(provider)
      .then((result) => {
        this.ngZone.run(() => {
          this.router.navigate(['onboard']);
        });
        this.SetUserData(result.user);
      })
      .catch((error) => {
        window.alert(error);
      });
  }

  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  SetUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );
    const userData: User = {
      uid: user.uid,
      email: user.email,
      displayName: user?.displayName,
      photoURL: user?.photoURL,
      typeOfUser: user?.typeOfUser || null,
      emailVerified: user.emailVerified,
      firstName: user?.firstName || null,
      lastName: user?.lastName || null,
      companyName: user?.companyName || null,
      refferedBy: user?.refferedBy || null,
      agreeToTerms: user?.agreeToTerms || null
    };
    for (const key in userData) {
      if (!userData[key]) {
        delete userData[key];
      }
    }
    return userRef.set(userData, {
      merge: true,
    });
  }

  typeOfAccount () {
    console.log(this.isSuperAdmin, "isSuperAdmin")
  }

  /* typeOfUser(user) {
     const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
     const userData: User = {
       uid: user.uid,
       email: user.email,
       displayName: user.displayName,
       photoURL: user.photoURL,
       typeOfUser: user.typeOfUser,
       emailVerified: user.emailVerified
     }
     return userRef.set(userData, {
       merge: true
     })
   }*/

  // Sign out
  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['sign-in']);
      this._snackBar.open('Successfully Signed out', '', {
        duration: 3000,
      });
      // location.reload();
    });
  }

  hideNav() {
    this.visible = false;
  }
  showNav() {
    this.visible = true;
  }
}
